import { Grid, Typography, Box, Button } from "@mui/material"
import warnImg from '../../assets/svg/rejected1.svg'
import { InfoOutlined } from "@mui/icons-material"

const NotifyInfo = ({ fieldType, onClose }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1 }}>
                <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 600, mb: 1 }}>
                    Unable to process your request!
                </Typography>

                <Box textAlign="center" mb={5} mt={5}>
                    <img src={warnImg} alt="OTP" width={250} height={250} />
                </Box>

                <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 500, mb: 1, color: '#FF9999' }}>
                   Unable to process your request!
                </Typography>

                <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 500, mb: 1 }}>
                   Please wait, your {fieldType === 'email' ? 'Mobile Number' : 'Email ID'} updation is already in progress
                </Typography>

            </Box>


            <Box>
                <Box display="flex" alignItems="center" mt={2} mb={2}>
                    <InfoOutlined fontSize="small" sx={{ color: "#888", mr: 1 }} />
                    <Typography sx={{ fontSize: '12px', color: "#888" }}>
                        Once your {fieldType === 'email' ? 'Mobile Number' : 'Email ID'} is updated then we can process your {fieldType === 'email' ? 'Email ID' : 'Mobile Number'} update request.
                    </Typography>
                </Box>

                <Button fullWidth onClick={onClose}>
                    Close
                </Button>
            </Box>
        </Box>
    )
}

export default NotifyInfo
